// Externe Bibliotheken
import React from 'react';

// Styles
import './tourGuideModal.scss';

const tourGuideModal = (tourGuideData) => {
    return (
        <>
            <div className="info">
                Die übermittelten Daten stimmen nicht? Dann melden Sie sich bitte beim AurumTours Serviceteam unter
                <a href="mailto:digitale.reiseleitung@aurumtours.de">digitale.reiseleitung@aurumtours.de</a>.
            </div>
            <div className="contact-data">
                {tourGuideData.firstName && tourGuideData.lastName && (
                    <div className="contact-data-headline">
                        {`Kontaktdaten von ${tourGuideData.firstName} ${tourGuideData.lastName}`}
                    </div>
                )}
                {tourGuideData.firstName && (
                    <div className="contact-data-row">
                        <div>Vorname</div>
                        <div>{tourGuideData.firstName}</div>
                    </div>
                )}
                {tourGuideData.lastName && (
                    <div className="contact-data-row">
                        <div>Nachname</div>
                        <div>{tourGuideData.lastName}</div>
                    </div>
                )}
                {tourGuideData.mobileNumber && (
                    <div className="contact-data-row">
                        <div>Mobilnummer</div>
                        <div>{tourGuideData.mobileNumber}</div>
                    </div>
                )}
            </div>
        </>
    );
};
export default tourGuideModal;
